import React, {useMemo}						from 'react';

import {AvatarProps}						from './interface';
import Icon									from '../Icon';

import ft_cssVar							from '../../functions/getCssVar';

import img_user								from '../../images/icon/user.svg';

import './Avatar.css';


function Avatar(props: AvatarProps): JSX.Element {
	const style: React.CSSProperties = useMemo(() => {
		const finalStyle = {...props.style};

		if (props.size) {
			finalStyle.maxHeight = props.size;
			finalStyle.maxWidth = props.size;
			finalStyle.minHeight = props.size;
			finalStyle.minWidth = props.size;
		}

		if (props.forceImage)
			finalStyle.backgroundImage = `url(${props.forceImage})`;
		else if (props.user?.profilePicture)
			finalStyle.backgroundImage = `url(${props.user.profilePicture})`;
		return finalStyle;
	}, [props.style, props.size, props.forceImage, props.user]);

	let first = props.firstname;
	let last = props.lastname;

	if (!props.user && !first && !last) {
		return (
			<div className={'avatarMainContainer'} style={style}>
				{!style.backgroundImage &&
					<Icon
						icon={img_user}
						iconColor={ft_cssVar('gray-600')}
					/>
				}
			</div>
		);
	}

	if (props.user) {
		first = props.user.firstname;
		last = props.user.lastname;
	}

	return (
		<div className={'avatarMainContainer'} style={style}>
			{!style.backgroundImage && first?.charAt(0)}
			{!style.backgroundImage && last?.charAt(0)}
		</div>
	);
}

export default Avatar;